// extracted by css-extract-rspack-plugin
export default {"link":"_a7afc1af"};